import React, { useEffect, useRef, useState } from "react";
import "./VScroll.css";

import Data from "../../Content/InovationEx/InovationEx.json";
import QuoteComp from "../QuoteComp/QuoteComp";
import {
  faArrowsDownToLine,
  faArrowsRotate,
  faBolt,
  faDumbbell,
  faEarDeaf,
  faGears,
  faLeaf,
  faRightLong,
  faShapes,
  faTemperature1,
  faWeightHanging,
} from "@fortawesome/free-solid-svg-icons";

const VScroll = () => {
  const data = Data as textAndBackground[];
  const icons = [
    faWeightHanging,
    faArrowsRotate,
    faShapes,
    faBolt,
    faGears,
    faTemperature1,
    faArrowsDownToLine,
    faDumbbell,
    faLeaf,
    faWeightHanging,
  ];

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        container.style.overflowY =
          entry.intersectionRatio >= 0.6 ? "scroll" : "hidden";
      },
      { threshold: [0, 0.6, 1.0] },
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="scroll-container">
      {/* add the Main Content section here so it all works together */}

      {data.map((item, index) => (
        <div key={index} className="vscroll-section">
          <QuoteComp text={item.text} isQuote={false} iconPath={icons[index]} />
        </div>
      ))}
    </div>
  );
};

export default VScroll;
